export default __webpack_public_path__ + "static/media/headerLogo.e3a32728.png";